/**
 * Image optimization utilities for responsive image rendering and srcset generation.
 */

export function getExactImageProps(getAssetUrl, src, size = 112, options = {}) {
  const { quality = 85, scales = [1, 2, 3], alt = '' } = options;

  if (!src) {
    return { src: '', alt };
  }

  const resolveUrl = typeof getAssetUrl === 'function' ? getAssetUrl : (s) => s;

  try {
    const defaultSrc = resolveUrl(src, { width: size, quality });
    const srcSet = scales
      .map(scale => {
        const scaledWidth = Math.round(size * scale);
        const scaledUrl = resolveUrl(src, { width: scaledWidth, quality });
        return `${scaledUrl} ${scale}x`;
      })
      .join(', ');

    return {
      src: defaultSrc,
      srcSet,
      alt,
      loading: 'lazy',
      decoding: 'async',
      width: size,
      height: size
    };
  } catch (_) {
    return {
      src: resolveUrl(src),
      alt,
      loading: 'lazy',
      decoding: 'async'
    };
  }
}

export default {
  getExactImageProps
};
